import { LANGUAGE_CODES } from '../../constants';

export const SEARCH_CALLBACK_DELAY: number = 600;
export const mainCompanyPageURL: string = 'https://www.contentoo.com';
export const defaultAppUrl = '/';

export const getDefaultProjectsPageURL = (lang = LANGUAGE_CODES.English): string => `/${lang}/dashboard/projects`;
